import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const googleSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-black border border-white/15 focus:border-[#C5A059] focus:ring-1 focus:ring-[#C5A059] outline-none px-4 py-3.5 text-sm text-white placeholder:text-zinc-600 transition-colors duration-300";

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-[#C5A059]/25 bg-[#0A0A0A] p-10">
        <div className="flex flex-col items-center mb-10">
          <img src="/images/logo.webp" alt="Taha Developers" className="h-16 w-16 object-cover rounded-full border border-[#C5A059]/40" />
          <h1 className="font-display text-2xl mt-6 tracking-tight" data-testid="admin-login-title">
            Admin Access
          </h1>
          <p className="font-accent text-[10px] tracking-[0.3em] uppercase text-zinc-500 mt-2">Taha Developers</p>
        </div>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <input
            type="email"
            required
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className={inputCls}
            data-testid="admin-email-input"
          />
          <input
            type="password"
            required
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className={inputCls}
            data-testid="admin-password-input"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit-button"
            className="w-full bg-[#C5A059] text-black font-accent text-xs tracking-[0.25em] uppercase px-8 py-4 hover:bg-[#D4AF37] transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <div className="flex items-center gap-4 my-6">
          <span className="flex-1 h-px bg-white/10" />
          <span className="font-accent text-[10px] tracking-[0.25em] uppercase text-zinc-600">or</span>
          <span className="flex-1 h-px bg-white/10" />
        </div>
        <button
          onClick={googleSignIn}
          data-testid="google-signin-button"
          className="w-full border border-white/15 text-white font-accent text-xs tracking-[0.25em] uppercase px-8 py-4 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors duration-300 flex items-center justify-center gap-3"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81Z"/>
          </svg>
          Sign in with Google
        </button>
        <a href="/" className="block text-center mt-8 font-accent text-[10px] tracking-[0.2em] uppercase text-zinc-600 hover:text-[#C5A059] transition-colors" data-testid="admin-back-to-site-link">
          ← Back to website
        </a>
      </div>
    </div>
  );
}
